module.exports = __webpack_public_path__ + "static/media/PM10.f9115a28.png";